// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2i44q","title":"Header_title__JfZ1-","left":"Header_left__2BAPF","clinicName":"Header_clinicName__27dVO"};